












import { Component, Vue } from 'vue-property-decorator';

import Wrapper from '@/components/layout/Wrapper.vue';
import HeadBanner from '@/components/homescapes/hs000v1/HeadBanner.vue';
import GamePreview from '@/components/homescapes/hs000v1/GamePreview.vue';
import SupportInfo from '@/components/homescapes/hs000v1/SupportInfo.vue';
import PageFooter from '@/components/common/PageFooter.vue';

@Component({
  components: {
    Wrapper,
    HeadBanner,
    GamePreview,
    SupportInfo,
    PageFooter,
  },
})
export default class HS000V1 extends Vue {}
